var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/extends", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "prop-types", "react", "../../css", "../../propTypes", "../../UI/Interchange/Interchange", "./TeaserMain.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/extends"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("prop-types"), require("react"), require("../../css"), require("../../propTypes"), require("../../UI/Interchange/Interchange"), require("./TeaserMain.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global._extends, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.propTypes, global.react, global.css, global.propTypes, global.Interchange, global.TeaserMain);
    global.TeaserMain = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _es6Regexp, _es6Date, _es6Object, _construct, _extends2, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty3, _propTypes, _react, _css, _propTypes2, _Interchange, _TeaserMain) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _construct = _interopRequireDefault(_construct);
  _extends2 = _interopRequireDefault(_extends2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _propTypes2 = _interopRequireDefault(_propTypes2);
  _Interchange = _interopRequireDefault(_Interchange);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var TeaserMain = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(TeaserMain, _PureComponent);

    var _super = _createSuper(TeaserMain);

    function TeaserMain(props) {
      var _this;

      (0, _classCallCheck2.default)(this, TeaserMain);
      _this = _super.call(this, props);
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "initTeaser", function (ref) {
        _this.teaser = ref;
      });
      _this.teaser = null;
      return _this;
    }

    (0, _createClass2.default)(TeaserMain, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            ariaHidden = _this$props.ariaHidden,
            beginsAt = _this$props.beginsAt,
            breakpointFormat = _this$props.breakpointFormat,
            className = _this$props.className,
            duration = _this$props.duration,
            hover = _this$props.hover,
            images = _this$props.images,
            isActive = _this$props.isActive,
            labels = _this$props.labels,
            lazyLoad = _this$props.lazyLoad,
            mouseFocus = _this$props.mouseFocus,
            pause = _this$props.pause,
            preload = _this$props.preload,
            renderLink = _this$props.renderLink,
            slideIndex = _this$props.slideIndex,
            tabIndex = _this$props.tabIndex,
            title = _this$props.title,
            titlesElement = _this$props.titlesElement,
            tracking = _this$props.tracking,
            unpause = _this$props.unpause,
            url = _this$props.url,
            urlRel = _this$props.urlRel,
            urlTarget = _this$props.urlTarget;
        var lazyLoadProps = lazyLoad ? {
          thumbnailEnabled: slideIndex < 1 || preload,
          visible: slideIndex < 1 || isActive
        } : {};
        var ariaProps = {
          tabIndex: tabIndex
        };

        if (ariaHidden) {
          ariaProps['aria-hidden'] = true;
        }

        var component = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Interchange.default, (0, _extends2.default)({
          breakpointFormat: breakpointFormat,
          images: images,
          hover: _css.hovers[hover],
          mouseFocus: mouseFocus,
          title: title
        }, lazyLoadProps)), /*#__PURE__*/_react.default.createElement("div", {
          className: "".concat(className, "__caption")
        }, titlesElement, duration > 0 && /*#__PURE__*/_react.default.createElement("p", {
          className: "".concat(className, "__duration")
        }, "".concat(duration, " ").concat(labels.durationUnit)), beginsAt && /*#__PURE__*/_react.default.createElement("p", {
          className: "".concat(className, "__date")
        }, beginsAt)));

        if (url) {
          var linkProps = _objectSpread(_objectSpread({}, ariaProps), {}, {
            className: 'teaser-focus',
            href: url,
            onBlur: unpause,
            onClick: tracking,
            onFocus: pause,
            onMouseOver: pause,
            onMouseLeave: unpause,
            rel: urlRel,
            target: urlTarget
          });

          return /*#__PURE__*/_react.default.createElement(_TeaserMain.StyledWrapper, {
            ref: this.initTeaser
          }, /*#__PURE__*/_react.default.createElement(_TeaserMain.StyledRenderedLink, (0, _extends2.default)({}, linkProps, {
            renderLink: renderLink
          }), component));
        }

        return /*#__PURE__*/_react.default.createElement(_TeaserMain.StyledWrapper, (0, _extends2.default)({}, ariaProps, {
          ref: this.initTeaser
        }), component);
      }
    }]);
    return TeaserMain;
  }(_react.PureComponent);

  TeaserMain.propTypes = {
    ariaHidden: _propTypes.default.bool,
    beginsAt: _propTypes.default.string,
    breakpointFormat: _propTypes.default.shape(),
    className: _propTypes.default.string,
    duration: _propTypes.default.number,
    hover: _propTypes.default.string,
    images: _propTypes.default.arrayOf(_propTypes.default.shape()).isRequired,
    isActive: _propTypes.default.bool,
    labels: _propTypes.default.shape({
      durationUnit: _propTypes.default.string,
      removeFavorite: ''
    }),
    lazyLoad: _propTypes.default.bool,
    mouseFocus: _propTypes.default.bool,
    pause: _propTypes.default.func.isRequired,
    preload: _propTypes.default.bool,
    renderLink: _propTypes.default.func,
    slideIndex: _propTypes.default.number,
    tabIndex: _propTypes.default.number.isRequired,
    title: _propTypes.default.string.isRequired,
    titlesElement: _propTypes.default.node,
    tracking: _propTypes.default.func,
    unpause: _propTypes.default.func.isRequired,
    url: _propTypes.default.string,
    urlRel: _propTypes.default.string,
    urlTarget: _propTypes.default.string,
    visible: _propTypes.default.bool
  };
  TeaserMain.defaultProps = {
    breakpointFormat: _propTypes2.default.breakpointFormat,
    className: 'next-teaser-full',
    // to be removed when Interchange has moved to emotion
    hover: 'mainRGAA',
    isActive: false,
    labels: {
      durationUnit: 'min',
      removeFavorite: ''
    },
    lazyLoad: false,
    mouseFocus: true,
    pause: function pause() {},
    preload: false,
    slideIndex: -1,
    tabIndex: 0,
    title: '',
    tracking: function tracking() {},
    unpause: function unpause() {},
    visible: true
  };
  var _default = TeaserMain;
  _exports.default = _default;
});